import { Ellipsis } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgDotsHorizontalTriple = mkIcon(Ellipsis);